import React from "react";

export function resetEngravingQueue() {}

export default function LaserEtchedLabel({ text, as: Tag = "span", className = "", children }) {
  return <Tag className={className}>{text ?? children}</Tag>;
}
